"use client";
import Image from "next/image";
import CustomerService from "@/public/images/customer-service.png"
import Link from "next/link";

const FloatButton = () => {
  return (
    <>
      <Link
        href="tel:0966665040"
        className="floating-button cursor-pointer p-2"
      >
        <Image
          width={36}
          height={36}
          src={CustomerService}
          alt="float-box"
          priority
        />
      </Link>
    </>
  );
};

export default FloatButton;
